import { useTranslation } from "react-i18next";
import ChangeRow from "../../../ui/content/ChangeRow";
import { plainTriple, type PlainTerm } from "../diff/plainTriples";

/** Added or removed triples, each as "subject — predicate — object" (FR-VERSION-7). */
export default function TripleList({
  title,
  lines,
  labels,
  tone,
}: {
  title: string;
  lines: readonly string[];
  labels: Readonly<Record<string, string>>;
  tone: "added" | "removed";
}) {
  const { t } = useTranslation();
  if (lines.length === 0) {
    return null;
  }
  return (
    <div>
      <h4 className="app-subsection-title text-sm">{title}</h4>
      <ul className="space-y-0.5 text-sm">
        {lines.map((line) => {
          const triple = plainTriple(line, labels);
          return (
            <ChangeRow key={line} kind={tone} title={line}>
              {triple === null ? (
                <span className="font-mono text-xs">{line}</span>
              ) : (
                <>
                  <Term term={triple.subject} />
                  <span className="app-text-muted"> {triple.predicateKey !== null ? t(`reviews.predicates.${triple.predicateKey}`) : triple.predicateName} </span>
                  <Term term={triple.object} />
                </>
              )}
            </ChangeRow>
          );
        })}
      </ul>
    </div>
  );
}

export function Term({ term }: { term: PlainTerm }) {
  const { t } = useTranslation();
  switch (term.kind) {
    case "term":
      return <span className="font-semibold" title={term.label === null ? term.iri : `${term.label} · ${term.iri}`}>{term.name}</span>;
    case "axiom":
      return <span className="app-text-muted italic">{t("reviews.item.axiom")}</span>;
    case "text":
      return <span>“{term.text}”{term.language !== null ? ` (${term.language})` : ""}</span>;
  }
}
